<template>
  <div>
    <v-tabs
      v-if="!isMobile"
      v-model="tab"
      background-color="transparent"
      color="primary"
      grow
      class="mt-5"
    >
      <v-tab v-for="item in ['Mobile', 'Desktop']" :key="item">
        {{ item }}
      </v-tab>
    </v-tabs>
    <div v-if="tab === 0" style="max-width: 45vh;" class="mx-auto">
      <div class="text-4 gray--text mt-10 text-center">
        Use MetaMask application on your mobile device to scan this QR Code to
        continue
      </div>
      <div class="p-relative mt-3">
        <img :src="dataUrl" style="max-width: 100%" />
        <span id="targetUrl" class="white--text-abs p-absolute site-url-text">{{
          metamaskDeeplink
        }}</span>
      </div>
      <div class="d-flex align-center justify-space-between mt-5">
        <div>
          <c-btn
            is-secondary
            class="copy-url"
            data-clipboard-target="#targetUrl"
            >Copy URL</c-btn
          >
        </div>
        <c-btn @click="$emit('next')">Close</c-btn>
      </div>
    </div>
    <div v-if="tab === 1" class="mt-10 text-center">
      <div>
        Download Metamask here:
        <a
          class="ml-1"
          href="https://metamask.io/download.html"
          target="_blank"
          rel="noopener noreferrer"
          >https://metamask.io/download.html</a
        >.
        <br />
        Click Try Again after you download and install MetaMask extension.
      </div>
      <div class="mt-5">
        <c-btn @click="tryAgain">Try Again</c-btn>
      </div>
    </div>
  </div>
</template>

<script>
import QrCode from "qrcode";
import Clipboard from "clipboard";
import { mapGetters } from "vuex";

export default {
  props: ["context", "data"],
  computed: mapGetters({
    isMobile: "appConfig/isMobile",
    accessToken: "auth/accessToken",
  }),
  data: () => ({
    metamaskDeeplink: null,
    targetUrl: null,
    dataUrl: null,
    tab: 0,
  }),
  methods: {
    openMetamaskApp() {
      const anchor = document.createElement("a");
      anchor.href = this.metamaskDeeplink;
      anchor.style.display = "none";
      anchor.click();
      anchor.remove();
    },
    tryAgain() {
      window.location.href = window.location.protocol + "//" + this.targetUrl;
    },
  },
  async mounted() {
    this.targetUrl =
      window.location.host +
      this.$router.resolve({
        path: this.$route.path,
        query: {
          accessToken: this.accessToken,
          ctx: this.context,
          data: btoa(JSON.stringify(this.data || {})),
        },
      }).href;
    this.metamaskDeeplink = `https://metamask.app.link/dapp/${this.targetUrl}`;
    this.dataUrl = await QrCode.toDataURL(this.metamaskDeeplink, {
      scale: 8,
      errorCorrectionLevel: "H",
    });
    if (this.isMobile) {
      this.openMetamaskApp();
    }
    const clipboard = new Clipboard(".copy-url");
  },
};
</script>


<style lang="scss" scoped>
.site-url-text {
  z-index: -1;
  font-size: 1px;
  bottom: 7px;
  right: 0;
}
</style>